// Packages
import React from "react";
import { Routes, Route } from "react-router-dom";

// Views
import useViews from "../../views";
import DocumentFollowUsers from "../../views/screens/Dashboard/View/Components/DocumentFollowUsers";
import AuthGuard from "../AuthGuard";
import KeycloakGuard from "../KeycloakGuard";
import PermissionGuard from "../PermissionGuard";

const PrivateRouting = () => {
  // Views
  const { useScreens } = useViews();

  const {
    Tools,
    Users,
    Roles,
    Tasks,
    Projects,
    UsersGroup,
    News,
    Notifications,
    Countries,
    Brands,
    Faqs,
    Payments,
    Profiler,
    Dashboard,
    Analytic,
    Membeer,
    PowerBI,
    Gamification,
    Map,
    Questions,
    Legal,
    PromptsMain,
    PromptConfigMain,
    SubItems,
    Settings,
    Login,
    MFA,
    Password,
    LaunchApp,
    NotFound
  } = useScreens();

  const { ForgotPassword, RecoveryPassword } = Password();

  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/mfa" element={<MFA />} />
      <Route path="/contrasena/olvidar" element={<ForgotPassword />} />
      <Route path="/contrasena/restablecer/:token" element={<RecoveryPassword />} />
      <Route path="/contrasena/restablecer/app/:tokenApp" element={<RecoveryPassword />} />
      <Route path="/launch" element={<LaunchApp />} />
      <Route path="/pdf/dashboard/chart" element={<DocumentFollowUsers />} />

      {/* Protected routes - require both Keycloak authentication and specific permissions */}
      <Route
        path="/herramientas/*"
        element={
          <AuthGuard>
            <PermissionGuard permissionKey="missions_flow.tools">
              <KeycloakGuard><Tools /></KeycloakGuard>
            </PermissionGuard>
          </AuthGuard>
        }
      />
      <Route
        path="/usuarios/*"
        element={
          <AuthGuard>
            <PermissionGuard permissionKey="configuration.admin_users">
              <KeycloakGuard><Users /></KeycloakGuard>
            </PermissionGuard>
          </AuthGuard>
        }
      />
      <Route
        path="/roles/*"
        element={
          <AuthGuard>
            <PermissionGuard permissionKey="configuration.roles">
              <KeycloakGuard><Roles /></KeycloakGuard>
            </PermissionGuard>
          </AuthGuard>
        }
      />
      <Route
        path="/misiones/*"
        element={
          <AuthGuard>
            <PermissionGuard permissionKey="missions_flow.missions">
              <KeycloakGuard><Tasks /></KeycloakGuard>
            </PermissionGuard>
          </AuthGuard>
        }
      />
      <Route
        path="/grupos/*"
        element={
          <AuthGuard>
            <PermissionGuard permissionKey="missions_flow.membeer_groups">
              <KeycloakGuard><UsersGroup /></KeycloakGuard>
            </PermissionGuard>
          </AuthGuard>
        }
      />
      <Route
        path="/proyectos/*"
        element={
          <AuthGuard>
            <PermissionGuard permissionKey="missions_flow.projects">
              <KeycloakGuard><Projects /></KeycloakGuard>
            </PermissionGuard>
          </AuthGuard>
        }
      />
      <Route
        path="/notificaciones/*"
        element={
          <AuthGuard>
            <PermissionGuard permissionKey="notifications">
              <KeycloakGuard><Notifications /></KeycloakGuard>
            </PermissionGuard>
          </AuthGuard>
        }
      />
      <Route
        path="/noticias/*"
        element={
          <AuthGuard>
            <PermissionGuard permissionKey="configuration.news">
              <KeycloakGuard><News /></KeycloakGuard>
            </PermissionGuard>
          </AuthGuard>
        }
      />
      <Route
        path="/paises/*"
        element={
          <AuthGuard>
            <PermissionGuard permissionKey="configuration.countries">
              <KeycloakGuard><Countries /></KeycloakGuard>
            </PermissionGuard>
          </AuthGuard>
        }
      />
      <Route
        path="/map/*"
        element={
          <AuthGuard>
            <PermissionGuard permissionKey="configuration.passive_tracking">
              <KeycloakGuard><Map /></KeycloakGuard>
            </PermissionGuard>
          </AuthGuard>
        }
      />
      <Route
        path="/qualitychecks/*"
        element={
          <AuthGuard>
            <PermissionGuard permissionKey="configuration.questions">
              <KeycloakGuard><Questions /></KeycloakGuard>
            </PermissionGuard>
          </AuthGuard>
        }
      />
      <Route
        path="/marcas/*"
        element={
          <AuthGuard>
            <PermissionGuard permissionKey="configuration.brands">
              <KeycloakGuard><Brands /></KeycloakGuard>
            </PermissionGuard>
          </AuthGuard>
        }
      />
      <Route
        path="/pagos/*"
        element={
          <AuthGuard>
            <PermissionGuard permissionKey="payments">
              <KeycloakGuard><Payments /></KeycloakGuard>
            </PermissionGuard>
          </AuthGuard>
        }
      />
      <Route
        path="/faq/*"
        element={
          <AuthGuard>
            <PermissionGuard permissionKey="configuration.faqs">
              <KeycloakGuard><Faqs /></KeycloakGuard>
            </PermissionGuard>
          </AuthGuard>
        }
      />
      <Route
        path="/configuracion/settings/*"
        element={
          <AuthGuard>
            <PermissionGuard permissionKey="configuration.settings" requireSuperAdmin>
              <KeycloakGuard><Settings /></KeycloakGuard>
            </PermissionGuard>
          </AuthGuard>
        }
      />
      <Route
        path="/perfilacion/*"
        element={
          <AuthGuard>
            <KeycloakGuard><Profiler /></KeycloakGuard>
          </AuthGuard>
        }
      />
      <Route
        path="/dashboard/*"
        element={
          <AuthGuard>
            <PermissionGuard permissionKey="dashboard">
              <KeycloakGuard><Dashboard /></KeycloakGuard>
            </PermissionGuard>
          </AuthGuard>
        }
      />
      <Route
        path="/analytics/*"
        element={
          <AuthGuard>
            <PermissionGuard permissionKey="results.analytics">
              <KeycloakGuard><Analytic /></KeycloakGuard>
            </PermissionGuard>
          </AuthGuard>
        }
      />
      <Route
        path="/membeers/*"
        element={
          <AuthGuard>
            <PermissionGuard permissionKey="membeers">
              <KeycloakGuard><Membeer /></KeycloakGuard>
            </PermissionGuard>
          </AuthGuard>
        }
      />
      <Route
        path="/powerbi/*"
        element={
          <AuthGuard>
            <PermissionGuard permissionKey="results.power_bi">
              <KeycloakGuard><PowerBI /></KeycloakGuard>
            </PermissionGuard>
          </AuthGuard>
        }
      />
      <Route
        path="/gamification/*"
        element={
          <AuthGuard>
            <PermissionGuard permissionKey="configuration.gamification">
              <KeycloakGuard><Gamification /></KeycloakGuard>
            </PermissionGuard>
          </AuthGuard>
        }
      />
      <Route
        path="/legales/*"
        element={
          <AuthGuard>
            <PermissionGuard permissionKey="configuration.legals">
              <KeycloakGuard><Legal /></KeycloakGuard>
            </PermissionGuard>
          </AuthGuard>
        }
      />
      <Route
        path="/prompts/*"
        element={
          <AuthGuard>
            <PermissionGuard permissionKey="ai.prompt_dictionary">
              <KeycloakGuard><PromptsMain /></KeycloakGuard>
            </PermissionGuard>
          </AuthGuard>
        }
      />
      <Route
        path="/prompt-config/*"
        element={
          <AuthGuard>
            <PermissionGuard permissionKey="ai.system_configuration">
              <KeycloakGuard><PromptConfigMain /></KeycloakGuard>
            </PermissionGuard>
          </AuthGuard>
        }
      />
      <Route
        path="/sub-items/*"
        element={
          <AuthGuard>
            <KeycloakGuard><SubItems /></KeycloakGuard>
          </AuthGuard>
        }
      />

      {/* Catch-all route for 404 - must be last */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default PrivateRouting;
